<template>
  <div>
    <div class="searchArea">
      <a-select v-model:value="inputs.clubId" placeholder="门店" style="width: 275px;">
        <a-select-option v-for="item in clubList" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
      </a-select>
      <a-select v-model:value="dateType" style="width: 170px; margin-left: 10px">
        <a-select-option value="SubscribeDate">订阅日期</a-select-option>
        <a-select-option value="UnsubscribeDate">取消订阅日期</a-select-option>
        <a-select-option value="ConfirmedDate">确认日期</a-select-option>
      </a-select>
      <a-range-picker v-model:value="dateRange" :placeholder="['开始日期', '结束日期']" />
      <a-button type="primary" shape="circle" @click="handleSearch">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>
      <a-button style="margin-left: 10px" @click="handleReset">重置</a-button>
      <a-button style="margin-left: 10px" type="primary" @click="exportExcel">
        <template #icon>
          <PlusOutlined />
        </template>
        导出清单
      </a-button>
    </div>

    <a-table id="subscribeTable" class="ant-table-striped" :columns="columns" :data-source="data" bordered rowKey="id"
      :scroll="{ x: 1800, y: 600 }" :pagination="false">
      <template #remark="{ text }">
        <span>{{ text || '' }}</span>
      </template>
      <template #operation="{ record }">
        <a @click="openRemarkModal(record)">编辑备注</a>
      </template>
    </a-table>
  </div>

  <!-- 备注编辑弹窗 -->
  <a-modal :visible="remarkModalVisible" title="编辑备注" width="400px" ok-text="保存" cancel-text="取消" @ok="saveRemark"
    @cancel="closeRemarkModal" destroyOnClose>
    <a-textarea v-model:value="remarkValue" placeholder="请输入备注" :rows="4" :maxlength="200" show-count />
  </a-modal>

  <promotionSummary v-model:visible="summaryVisible" :dateRange="dateRange" />
</template>

<script>
import { SearchOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { SubscribeList, UpdateSubscribeRemark } from "/src/api/wechatOA.js";
import { ClubList } from "/src/api/businessManage/summary.js";
import { doExcel } from "/src/utils/doExcel.js";
import moment from "moment";
import promotionSummary from "/src/components/marketing/promotionSummary.vue";

export default {
  name: "公众号推广管理",
  components: { SearchOutlined, PlusOutlined, promotionSummary },
  data() {
    return {
      dateRange: [],
      dateType: "SubscribeDate",
      data: [],
      summaryVisible: false,
      clubList: [],
      inputs: {
        clubId: undefined,
      },
      remarkModalVisible: false,
      remarkValue: '',
      remarkRecordId: null,
      columns: [
        {
          title: "序号",
          key: "index",
          width: 60,
          align: "center",
          customRender: ({ index }) => index + 1,
        },
        {
          title: "粉丝OpenID",
          dataIndex: "openId",
          key: "openId",
          width: 160,
          align: "center",
          customRender: ({ text }) => {
            if (!text) return "";
            const masked = text.length > 8
              ? text.substring(0, 4) + "****" + text.substring(text.length - 4)
              : text;
            return (
              <a-tooltip title={text}>
                <span>{masked}</span>
              </a-tooltip>
            );
          },
        },
        {
          title: "邀请客服",
          dataIndex: "promoteEmployeeName",
          key: "promoteEmployeeName",
          width: 100,
          align: "center",
          filters: [],
          onFilter: (value, record) => record.promoteEmployeeName === value,
        },
        { title: "关注时间", dataIndex: "lastSubscribeTime", key: "lastSubscribeTime", width: 140, align: "center" },
        { title: "取关时间", dataIndex: "lastUnsubscribeTime", key: "lastUnsubscribeTime", width: 140, align: "center" },
        {
          title: "当前关注天数",
          dataIndex: "subscribeDays",
          key: "subscribeDays",
          width: 110,
          align: "center",
          customCell: (record) => {
            if (record.subscribeDays !== undefined && record.subscribeDays !== null && record.subscribeDays >= 30) {
              return {
                class: "cell-green",
              };
            }
            return {};
          },
        },
        {
          title: "是否仍关注",
          dataIndex: "subscribed",
          key: "subscribed",
          width: 120,
          align: "center",
          filters: [
            { text: "是", value: true },
            { text: "否", value: false },
          ],
          onFilter: (value, record) => record.subscribed === value,
          customRender: ({ text }) => {
            if (text === null || text === undefined) return "";
            return text ? "是" : "否";
          },
        },
        // {
        //   title: "满30天日期",
        //   dataIndex: "subscribe30Date",
        //   key: "subscribe30Date",
        //   width: 120,
        //   align: "center",
        //   customCell: (record) => {
        //     if (record.subscribe30Date) {
        //       const dateText = String(record.subscribe30Date).split("T")[0];
        //       const dateObj = new Date(dateText);
        //       const today = new Date();
        //       today.setHours(0, 0, 0, 0);
        //       if (dateObj < today) {
        //         return {
        //           class: "cell-green",
        //         };
        //       }
        //     }
        //     return {};
        //   },
        // },
        {
          title: "是否有效奖励粉丝",
          dataIndex: "confirmed",
          key: "confirmed",
          width: 160,
          align: "center",
          filters: [
            { text: "是", value: true },
            { text: "否", value: false },
          ],
          onFilter: (value, record) => record.confirmed === value,
          customCell: (record) => {
            if (record.confirmed !== undefined && record.confirmed !== null && record.confirmed) {
              return {
                class: "cell-green",
              };
            }
            return {};
          },
          customRender: ({ text }) => {
            if (text === null || text === undefined) return "";
            return text ? "是" : "否";
          },
        },
        {
          title: "优惠券",
          dataIndex: "couponUsed",
          key: "couponUsed",
          width: 140,
          align: "center",
          filters: [
            { text: "是", value: true },
            { text: "否", value: false },
          ],
          onFilter: (value, record) => record.couponUsed === value,
          customCell: (record) => {
            if (record.couponUsed !== undefined && record.couponUsed !== null && record.couponUsed) {
              return {
                class: "cell-green",
              };
            }
            return {};
          },
          customRender: ({ text }) => {
            if (text === null || text === undefined) return "";
            return text ? "是" : "否";
          },
        },
        {
          title: () => (
            <span>
              确认时间
              <span
                title="每日凌晨系统自动确认订阅满30天的用户"
                style="display: inline-block; width: 16px; height: 16px; line-height: 16px; border-radius: 50%; background: #108ee9; color: #fff; font-size: 12px; text-align: center; margin-left: 4px; cursor: help;"
              >?</span>
            </span>
          ),
          dataIndex: "confirmedTime",
          key: "confirmedTime",
          width: 160,
          align: "center",
          customCell: (record) => {
            if (record.confirmed !== undefined && record.confirmed !== null && record.confirmed) {
              return {
                class: "cell-green",
              };
            }
            return {};
          },
          customRender: ({ text }) => {
            if (!text) return "";
            return String(text).split("T")[0];
          },
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          width: 180,
          align: "center",
          slots: {
            customRender: "remark",
          },
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          width: 100,
          align: "center",
          slots: {
            customRender: "operation",
          },
        },
      ],
    };
  },
  mounted() {
    const from = moment().subtract(29, "days").format("YYYY-MM-DD");
    const to = moment().format("YYYY-MM-DD");
    this.dateRange = [moment(from, "YYYY-MM-DD"), moment(to, "YYYY-MM-DD")];
    this.init();
  },
  methods: {
    init() {
      this.getClubList();
    },
    async getClubList() {
      try {
        const res = await ClubList();
        if (res.errCode === 0 && res.data) {
          this.clubList = res.data;
          if (this.clubList.length === 1) {
            this.inputs.clubId = this.clubList[0].id;
            this.handleSearch();
          }
        }
      } catch (error) {
        console.error("获取门店异常:", error);
      }
    },
    getRange() {
      const from = this.dateRange && this.dateRange[0] ? this.dateRange[0].format("YYYY-MM-DD") : undefined;
      const to = this.dateRange && this.dateRange[1] ? this.dateRange[1].format("YYYY-MM-DD") : undefined;
      return { startDate: from, endDate: to };
    },
    async handleSearch() {
      if (!this.inputs.clubId) {
        this.$message && this.$message.error("请选择门店");
        return;
      }
      try {
        const range = this.getRange();
        const params = {
          appId: "wx443985c11eb1325b",
          clubId: this.inputs.clubId,
          dateType: this.dateType,
          ...range,
        };
        const res = await SubscribeList(params);
        if (res.errCode === 0) {
          const list = (res.data || []).map((item) => ({
            ...item,
            lastSubscribeTime: item.lastSubscribeTime ? item.lastSubscribeTime.split("T")[0] : "",
            lastUnsubscribeTime: item.lastUnsubscribeTime ? item.lastUnsubscribeTime.split("T")[0] : "",
            subscribe30Date: item.subscribe30Date ? item.subscribe30Date.split("T")[0] : "",
            confirmedTime: item.confirmedTime ? item.confirmedTime.split("T")[0] : "",
          }));
          this.data = list;
          // 动态更新邀请客服筛选选项
          const employeeOptions = [...new Set(list.map((item) => item.promoteEmployeeName).filter(Boolean))]
            .map((name) => ({ text: name, value: name }));
          const employeeCol = this.columns.find((col) => col.key === "promoteEmployeeName");
          if (employeeCol) {
            employeeCol.filters = employeeOptions;
          }
        }
      } catch (error) {
        console.error(error);
        this.$message && this.$message.error("查询失败");
      }
    },
    handleReset() {
      const from = moment().subtract(29, "days").format("YYYY-MM-DD");
      const to = moment().format("YYYY-MM-DD");
      this.dateRange = [moment(from, "YYYY-MM-DD"), moment(to, "YYYY-MM-DD")];
      this.inputs = {
        clubId: undefined,
      };
    },
    showSummary() {
      this.summaryVisible = true;
    },
    exportExcel() {
      const range = this.getRange();
      const filename = "订阅号推广" + (range.startDate || "") + "-" + (range.endDate || "");
      // 导出时剔除“操作”列
      doExcel("subscribeTable", filename, ["操作"]);
    },
    openRemarkModal(record) {
      this.remarkRecordId = record.id;
      this.remarkValue = record.remark || '';
      this.remarkModalVisible = true;
    },
    closeRemarkModal() {
      this.remarkModalVisible = false;
      this.remarkValue = '';
      this.remarkRecordId = null;
    },
    async saveRemark() {
      if (!this.remarkRecordId) return;
      try {
        const res = await UpdateSubscribeRemark({ id: this.remarkRecordId, remark: this.remarkValue });
        if (res.errCode === 0) {
          this.$message && this.$message.success("备注更新成功");
          const item = this.data.find((d) => d.id === this.remarkRecordId);
          if (item) {
            item.remark = this.remarkValue;
          }
          this.closeRemarkModal();
        }
      } catch (error) {
        console.error(error);
        this.$message && this.$message.error("备注更新失败");
      }
    },
  },
};
</script>

<style scoped></style>